module.exports = __webpack_public_path__ + "static/media/breakfast.802c3f85.jpg";